export const phoneRegex = /^\(\d{2}\) \d \d{4}-\d{4}$/;
export const emailRegex = /\S+@\S+\.\S+/;
export const corporateEmailRegex =
  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
export const domainValidationRegex =
  /@(gmail\.com|yahoo\.com|hotmail\.com|live\.com)$/;
export const codeEmailValidation = /^[0-9A-Z]?$/;
